__turbopack_context__.v({
  "content": "IntroductionBlock-module-scss-module__3oJvQq__content",
  "eyebrow": "IntroductionBlock-module-scss-module__3oJvQq__eyebrow",
  "eyebrowWrapper": "IntroductionBlock-module-scss-module__3oJvQq__eyebrowWrapper",
  "inner": "IntroductionBlock-module-scss-module__3oJvQq__inner",
  "introductionBlock": "IntroductionBlock-module-scss-module__3oJvQq__introductionBlock",
  "stack-module-0": "IntroductionBlock-module-scss-module__3oJvQq__stack-module-0",
  "stack-module-1": "IntroductionBlock-module-scss-module__3oJvQq__stack-module-1",
  "stack-module-10": "IntroductionBlock-module-scss-module__3oJvQq__stack-module-10",
  "stack-module-11": "IntroductionBlock-module-scss-module__3oJvQq__stack-module-11",
  "stack-module-12": "IntroductionBlock-module-scss-module__3oJvQq__stack-module-12",
  "stack-module-13": "IntroductionBlock-module-scss-module__3oJvQq__stack-module-13",
  "stack-module-14": "IntroductionBlock-module-scss-module__3oJvQq__stack-module-14",
  "stack-module-15": "IntroductionBlock-module-scss-module__3oJvQq__stack-module-15",
  "stack-module-16": "IntroductionBlock-module-scss-module__3oJvQq__stack-module-16",
  "stack-module-17": "IntroductionBlock-module-scss-module__3oJvQq__stack-module-17",
  "stack-module-18": "IntroductionBlock-module-scss-module__3oJvQq__stack-module-18",
  "stack-module-19": "IntroductionBlock-module-scss-module__3oJvQq__stack-module-19",
  "stack-module-2": "IntroductionBlock-module-scss-module__3oJvQq__stack-module-2",
  "stack-module-20": "IntroductionBlock-module-scss-module__3oJvQq__stack-module-20",
  "stack-module-3": "IntroductionBlock-module-scss-module__3oJvQq__stack-module-3",
  "stack-module-4": "IntroductionBlock-module-scss-module__3oJvQq__stack-module-4",
  "stack-module-5": "IntroductionBlock-module-scss-module__3oJvQq__stack-module-5",
  "stack-module-6": "IntroductionBlock-module-scss-module__3oJvQq__stack-module-6",
  "stack-module-7": "IntroductionBlock-module-scss-module__3oJvQq__stack-module-7",
  "stack-module-8": "IntroductionBlock-module-scss-module__3oJvQq__stack-module-8",
  "stack-module-9": "IntroductionBlock-module-scss-module__3oJvQq__stack-module-9",
  "z-base": "IntroductionBlock-module-scss-module__3oJvQq__z-base",
  "z-content": "IntroductionBlock-module-scss-module__3oJvQq__z-content",
  "z-footer": "IntroductionBlock-module-scss-module__3oJvQq__z-footer",
  "z-header": "IntroductionBlock-module-scss-module__3oJvQq__z-header",
  "z-hero": "IntroductionBlock-module-scss-module__3oJvQq__z-hero",
  "z-logo": "IntroductionBlock-module-scss-module__3oJvQq__z-logo",
  "z-logo-effect": "IntroductionBlock-module-scss-module__3oJvQq__z-logo-effect",
  "z-navigation": "IntroductionBlock-module-scss-module__3oJvQq__z-navigation",
  "z-sub": "IntroductionBlock-module-scss-module__3oJvQq__z-sub",
});
